"use client";

import { createDraftReport, updateCaseStatus } from "@/app/actions";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Label, Select, Textarea } from "@/components/ui/input";
import { useRouter } from "next/navigation";
import { reportTypeLabel, statusLabel } from "@/lib/labels";

export function CaseActions({
  caseId,
  statuses,
  reportTypes,
}: {
  caseId: string;
  statuses: readonly string[];
  reportTypes: string[];
}) {
  const router = useRouter();
  return (
    <div className="grid gap-4 lg:grid-cols-2">
      <Card>
        <CardContent>
          <form
            className="space-y-3"
            action={async (formData) => {
              await updateCaseStatus(
                caseId,
                formData.get("status") as never,
                String(formData.get("notes") ?? ""),
              );
              router.refresh();
            }}
          >
            <Label>Case status</Label>
            <Select name="status">
              {statuses.map((s) => (
                <option key={s} value={s}>
                  {statusLabel(s)}
                </option>
              ))}
            </Select>
            <Label>Notes</Label>
            <Textarea name="notes" />
            <Button type="submit">Save case</Button>
          </form>
        </CardContent>
      </Card>
      <Card>
        <CardContent>
          <form
            className="space-y-3"
            action={async (formData) => {
              formData.set("caseId", caseId);
              const result = await createDraftReport(formData);
              router.push(`/reports/${result.report.id}`);
            }}
          >
            <Label>Report type</Label>
            <Select name="reportType">
              {reportTypes.map((t) => (
                <option key={t} value={t}>
                  {reportTypeLabel(t)}
                </option>
              ))}
            </Select>
            <p className="text-xs text-[var(--text-muted)]">
              Creating a draft does not send anything. Review it first. The provider will not take the content down automatically.
            </p>
            <Button type="submit">Create draft</Button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
}
